/* =============================================================
   Murmures d'Iqra — Moteur calendaire islamique v3
   Catalogue 100% automatique via window.IQRA_PRODUCTS (Liquid)
   Aucune maintenance manuelle : tout nouveau produit est detecte
   automatiquement des qu'il est mis en vente sur le shop.
   Architecture :
     1. iqra-product-catalog.liquid   : injecte IQRA_PRODUCTS (JSON)
     2. iqra-calendar-engine.js (ce fichier) : calcul hijri + evenements
     3. seasonal-product-modal.liquid : modale d'affichage
     4. announcement-ticker.liquid    : slot 5 dynamique
   Mise a jour : juin 2026 — v3 catalogue dynamique
============================================================= */
(function (G) {

  /* ── 1. Conversion gregorien -> hijri (Umm al-Qura approche) ── */
  function toHijri(date) {
    var JD = Math.floor((date.getTime() / 86400000) + 2440587.5);
    var l  = JD - 1948440 + 10632;
    var n  = Math.floor((l - 1) / 10631);
    l = l - 10631 * n + 354;
    var j  = (Math.floor((10985 - l) / 5316)) * (Math.floor((50 * l) / 17719)) +
             (Math.floor(l / 5670)) * (Math.floor((43 * l) / 15238));
    l = l - (Math.floor((30 - j) / 15)) * (Math.floor((17719 * j) / 50)) -
            (Math.floor(j / 16)) * (Math.floor((15238 * j) / 43)) + 29;
    var month = Math.floor((24 * l) / 709);
    var day   = l - Math.floor((709 * month) / 24);
    var year  = 30 * n + j - 30;
    return { y: year, m: month, d: day };
  }

  /* ── 2. Résolution automatique des produits depuis le catalogue live ── */
  /*
    resolveProducts(tags, limit)
    - tags   : tableau de strings. Un produit matche si AU MOINS UN de
               ses tags contient l'une des chaines cherchees (includes).
    - limit  : nombre max de produits retournes (defaut 3)
    - Trie par pertinence : nombre de tags matches en premier.
    - Retourne toujours des produits disponibles a la vente.
  */
  function resolveProducts(tags, limit) {
    limit = limit || 3;
    var catalog = G.IQRA_PRODUCTS || [];
    if (!catalog.length) return [];

    var lowerTags = tags.map(function (t) { return t.toLowerCase(); });

    var scored = [];
    catalog.forEach(function (p) {
      if (!p.available) return;
      var ptags = (p.tags || '').split(',').map(function (t) { return t.trim(); });
      var score = 0;
      lowerTags.forEach(function (st) {
        ptags.forEach(function (pt) {
          if (pt.indexOf(st) !== -1) score++;
        });
      });
      if (score > 0) scored.push({ p: p, score: score });
    });

    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, limit).map(function (x) { return x.p; });
  }

  /* ── 3. Normalisation d'un produit pour la modale ── */
  function normalizeProduct(p) {
    return {
      handle: p.handle,
      title:  p.title,
      url:    p.url,
      price:  p.price,
      image:  p.image || '',
      type:   (p.type && (p.type.indexOf('physique') !== -1 || p.type.indexOf('carnet') !== -1 || p.type.indexOf('patisserie') !== -1))
              ? 'physique' : 'numerique'
    };
  }

  /* ── 4. Evenements islamiques — tags de correspondance automatique ── */
  /*
    Chaque evenement declare :
      hm          : mois hijri (1-12)
      hd_start    : jour debut
      hd_end      : jour fin
      label       : nom affiche
      ticker      : texte bande defilante (max ~55 chars)
      icon        : emoji
      urgency     : 0-3 (3 = priorite max : Ramadan, Eid)
      tags        : tags Shopify a chercher dans le catalogue (OR logique)
      fallback    : tags alternatifs si aucun produit trouve avec les premiers
      cta_collection : URL collection de la CTA principale
      cta_label   : texte du bouton
      modal_title : titre de la modale
      modal_desc  : description de la modale
  */
  var EVENTS = [

    /* ── Ramadan (mois 9, jours 1-24) ── */
    {
      hm:9, hd_start:1, hd_end:24, urgency:3,
      label: 'Ramadan',
      ticker: 'Ramadan Moubarak \u2756 Nos ressources pour ce mois beni',
      icon: '\uD83C\uDF19',
      tags: ['ramadan','dhikr','adhkar','spiritualite','salat','priere','agenda','hijri'],
      fallback: ['digital','numerique','apprendre'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Ressources Ramadan',
      modal_title: 'Le Ramadan est commence \u2014 tes outils t\u2019attendent',
      modal_desc: 'Adhkars, programme de salat, agenda hijri : tout pour vivre ce mois avec intention.'
    },

    /* ── Laylat al-Qadr (mois 9, jours 25-29) ── */
    {
      hm:9, hd_start:25, hd_end:29, urgency:3,
      label: 'Laylat al-Qadr',
      ticker: 'Laylat al-Qadr \u2756 La nuit qui vaut 1000 mois',
      icon: '\u2B50',
      tags: ['dhikr','adhkar','salat','priere','spiritualite','ramadan'],
      fallback: ['digital','apprendre'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Ressources Nuit du Destin',
      modal_title: 'La Nuit du Destin approche',
      modal_desc: 'Maximise ton ibadah avec des adhkars et un programme de salat intense.'
    },

    /* ── Pre-Ramadan : Sha'ban 2e moitie (mois 8, jours 15-29) ── */
    {
      hm:8, hd_start:15, hd_end:29, urgency:3,
      label: 'Pre-Ramadan',
      ticker: 'Le Ramadan approche \u2756 Prepare-toi des maintenant',
      icon: '\uD83C\uDF19',
      tags: ['agenda','hijri','planner','ramadan','adhkar','salat'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/agendas-et-planners-islamiques',
      cta_label: 'Preparer mon Ramadan',
      modal_title: 'Sha\u2019ban s\u2019acheve \u2014 le Ramadan dans quelques jours',
      modal_desc: 'Agenda hijri, programme de salat, adhkars : mets tes routines en place avant le mois sacre.'
    },

    /* ── Aid al-Fitr (mois 10, jours 1-3) ── */
    {
      hm:10, hd_start:1, hd_end:3, urgency:3,
      label: 'Aid al-Fitr',
      ticker: 'Aid Moubarak \u2756 Notre selection cadeaux pour l\u2019Aid',
      icon: '\uD83C\uDF89',
      tags: ['cadeau','bestseller','pack','bundle','journal','yaqeen'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/frontpage',
      cta_label: 'Cadeaux pour l\u2019Aid',
      modal_title: 'Aid Moubarak ! \u2756',
      modal_desc: 'Celebre ce jour beni avec un cadeau qui a du sens pour ta famille ou tes proches.'
    },

    /* ── Saison des mariages Shawwal (mois 10, jours 4-29) ── */
    {
      hm:10, hd_start:4, hd_end:29, urgency:2,
      label: 'Saison des mariages',
      ticker: 'Saison des mariages \u2756 Pack nikah et invitations islamiques',
      icon: '\uD83D\uDC8D',
      tags: ['mariage','nikah','cadeau mariage','kit','invitations'],
      fallback: ['mariage islamique','islamique'],
      cta_collection: '/collections/mariage-islamique',
      cta_label: 'Voir le pack mariage',
      modal_title: 'Shawwal, le mois des mariages islamiques',
      modal_desc: 'Contrat de nikah, invitations et guides : tout pour une union benie, cle en main.'
    },

    /* ── Dhul Qidah (mois 11) ── */
    {
      hm:11, hd_start:1, hd_end:29, urgency:1,
      label: 'Dhul Qidah',
      ticker: 'Dhul Qidah \u2756 Mois sacre \u2014 ibadah et spiritualite',
      icon: '\u2728',
      tags: ['salat','dhikr','adhkar','spiritualite','priere'],
      fallback: ['digital','apprendre'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Mes outils spirituels',
      modal_title: 'Dhul Qidah, un mois sacre pour l\u2019ibadah',
      modal_desc: 'Renforce ta salat et tes adhkars en ce mois interdit, propice a l\u2019ibadah.'
    },

    /* ── Dhul Hijja 1-9 (mois 12) ── */
    {
      hm:12, hd_start:1, hd_end:9, urgency:2,
      label: 'Dhul Hijja',
      ticker: 'Dhul Hijja \u2756 Les 10 jours les plus benis de l\u2019annee',
      icon: '\uD83D\uDD4C',
      tags: ['dhikr','adhkar','coran','memorisation','salat','spiritualite'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Ressources Dhul Hijja',
      modal_title: 'Les 10 jours de Dhul Hijja ont commence',
      modal_desc: 'Les jours les plus benis de l\u2019annee : adhkars, Coran et salat intensifiee.'
    },

    /* ── Aid al-Adha (mois 12, jours 10-13) ── */
    {
      hm:12, hd_start:10, hd_end:13, urgency:3,
      label: 'Aid al-Adha',
      ticker: 'Aid al-Adha Moubarak \u2756 Cadeaux pour toute la famille',
      icon: '\uD83D\uDC11',
      tags: ['bestseller','pack','bundle','cadeau','journal','parentalite'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/frontpage',
      cta_label: 'Cadeaux Aid al-Adha',
      modal_title: 'Aid al-Adha Moubarak \u2756',
      modal_desc: 'Un jour de sacrifice et de gratitude : offre un cadeau islamique durable.'
    },

    /* ── Mouharram 1-8 : Nouvel an hijri (mois 1) ── */
    {
      hm:1, hd_start:1, hd_end:8, urgency:2,
      label: 'Nouvel an hijri',
      ticker: 'Bonne annee hijri \u2756 Nouveaux agendas islamiques disponibles',
      icon: '\uD83D\uDCC5',
      tags: ['agenda','hijri','planner','journal','yaqeen'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/agendas-et-planners-islamiques',
      cta_label: 'Mes agendas islamiques',
      modal_title: 'Une nouvelle annee hijri commence',
      modal_desc: 'Agenda Al Mounir, Journal de Yaqeen : pose tes intentions pour cette annee.'
    },

    /* ── Achoura (mois 1, jours 9-10) ── */
    {
      hm:1, hd_start:9, hd_end:10, urgency:2,
      label: 'Achoura',
      ticker: 'Achoura \u2756 Moise, le jeune et la gratitude \u2014 ressources',
      icon: '\uD83D\uDCCE',
      tags: ['coran','memorisation','dhikr','spiritualite','foi'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/coran-et-apprentissage-coranique',
      cta_label: 'Ressources Achoura',
      modal_title: 'Achoura : le jour ou Allah sauva Moise',
      modal_desc: 'Jeune, adhkars, lecture du Coran : nos ressources pour marquer cette journee.'
    },

    /* ── Mouharram milieu (mois 1, jours 11-29) ── */
    {
      hm:1, hd_start:11, hd_end:29, urgency:1,
      label: 'Mouharram',
      ticker: 'Mouharram \u2756 Renforcer ses routines en debut d\u2019annee',
      icon: '\uD83C\uDF1F',
      tags: ['salat','adhkar','dhikr','agenda','spiritualite'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Mes outils du debut d\u2019annee',
      modal_title: 'Mouharram : le mois de l\u2019intention',
      modal_desc: 'Salat, adhkars et agenda : les outils pour ancrer de bonnes habitudes.'
    },

    /* ── Safar : naissances et aqiqah (mois 2) ── */
    {
      hm:2, hd_start:1, hd_end:29, urgency:1,
      label: 'Safar',
      ticker: 'Naissances & aqiqah \u2756 Tracker bebe et parentalite islamique',
      icon: '\uD83C\uDF38',
      tags: ['bebe','maternite','maman','parentalite','tarbiyyah','aqiqah','naissance'],
      fallback: ['enfant','famille'],
      cta_collection: '/collections/maternite-et-nouveaux-parents',
      cta_label: 'Ressources maternite islamique',
      modal_title: 'Une naissance, c\u2019est aussi une tarbiyyah',
      modal_desc: 'Tracker bebe zen et guide de parentalite prophetique : pour les mamans de la communaute.'
    },

    /* ── Rabi al-Awwal : Mawlid (mois 3, jours 8-14) ── */
    {
      hm:3, hd_start:8, hd_end:14, urgency:2,
      label: 'Mawlid an-Nabi',
      ticker: 'Mawlid \u2756 Ressources sur la vie du Prophete',
      icon: '\u2600\uFE0F',
      tags: ['coran','memorisation','juzz-amma','tajwid','dhikr','yaqeen','foi'],
      fallback: ['apprendre','spiritualite'],
      cta_collection: '/collections/coran-et-apprentissage-coranique',
      cta_label: 'Ressources Seerah',
      modal_title: 'Mawlid an-Nabi',
      modal_desc: 'Memorisation du Coran, journal islamique et adhkars : honore le Prophete par l\u2019ibadah.'
    },

    /* ── Rabi al-Awwal hors Mawlid (mois 3, jours 1-7 et 15-29) ── */
    {
      hm:3, hd_start:1, hd_end:7, urgency:1,
      label: 'Rabi al-Awwal',
      ticker: 'Rabi al-Awwal \u2756 Mois de la naissance du Prophete',
      icon: '\u2600\uFE0F',
      tags: ['coran','memorisation','salat','dhikr','yaqeen'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/coran-et-apprentissage-coranique',
      cta_label: 'Apprendre sur le Prophete',
      modal_title: 'Rabi al-Awwal : mois du Prophete',
      modal_desc: 'Un mois pour se rapprocher du Coran et de la Seerah prophetique.'
    },

    /* ── Rabi al-Thani : naissances printemps (mois 4) ── */
    {
      hm:4, hd_start:1, hd_end:29, urgency:1,
      label: 'Rabi al-Thani',
      ticker: 'Saison des naissances \u2756 Aqiqah, bebe et maman islamique',
      icon: '\uD83C\uDF3C',
      tags: ['bebe','maternite','maman','parentalite','tarbiyyah','mariage','nikah'],
      fallback: ['famille','enfant'],
      cta_collection: '/collections/maternite-et-nouveaux-parents',
      cta_label: 'Ressources naissance islamique',
      modal_title: 'Saison des naissances et des familles',
      modal_desc: 'Tracker bebe, parentalite prophetique : pour les mamans et futures mamans.'
    },

    /* ── Jumada al-Oula : sante mentale (mois 5) ── */
    {
      hm:5, hd_start:1, hd_end:29, urgency:0,
      label: 'Jumada al-Oula',
      ticker: 'Bien-etre islamique \u2756 Sante mentale et routines prophetiques',
      icon: '\uD83C\uDF3F',
      tags: ['tdah','sante-mentale','anxiete','neurosciences','focus','salat','dhikr'],
      fallback: ['sante','bien-etre','digital'],
      cta_collection: '/collections/sante-mentale-et-bien-etre-islamique',
      cta_label: 'Mon bien-etre islamique',
      modal_title: 'Prends soin de ta sante mentale avec l\u2019islam',
      modal_desc: 'Guide TDAH, programme de salat et adhkars : calmer l\u2019anxiete avec la foi.'
    },

    /* ── Jumada al-Thania : finances (mois 6) ── */
    {
      hm:6, hd_start:1, hd_end:29, urgency:0,
      label: 'Jumada al-Thania',
      ticker: 'Finances halal \u2756 Gere ton argent selon l\u2019islam',
      icon: '\uD83D\uDCB0',
      tags: ['finance','halal','riba','zakat','budget','epargne'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/finances-halal',
      cta_label: 'Mon guide finances halal',
      modal_title: 'As-tu fait le point sur tes finances ?',
      modal_desc: 'Zakat, epargne halal, budget islamique : le guide 2026 pour gerer son argent.'
    },

    /* ── Rajab hors Isra (mois 7, jours 1-26 et 28-29) ── */
    {
      hm:7, hd_start:1, hd_end:26, urgency:1,
      label: 'Rajab',
      ticker: 'Rajab \u2756 Mois sacre \u2014 ibadah et spiritualite',
      icon: '\u2728',
      tags: ['dhikr','adhkar','salat','spiritualite','yaqeen','journal'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Ressources Rajab',
      modal_title: 'Rajab : un mois sacre pour l\u2019ibadah',
      modal_desc: 'Renforce ta salat et tes adhkars avant le Ramadan.'
    },

    /* ── Isra wal Miraj (mois 7, jour 27) ── */
    {
      hm:7, hd_start:27, hd_end:27, urgency:2,
      label: 'Isra wal Miraj',
      ticker: 'Isra wal Miraj \u2756 Le voyage nocturne du Prophete',
      icon: '\uD83C\uDF0C',
      tags: ['salat','priere','khushu','dhikr','coran'],
      fallback: ['spiritualite','digital'],
      cta_collection: '/collections/spiritualite-et-dhikr',
      cta_label: 'Ressources spirituelles',
      modal_title: 'Isra wal Miraj \u2014 le don de la salat',
      modal_desc: 'Ce voyage nocturne nous a offert la priere. Renforce la tienne avec notre programme 21 jours.'
    },

    /* ── Sha'ban 1ere moitie (mois 8, jours 1-14) ── */
    {
      hm:8, hd_start:1, hd_end:14, urgency:1,
      label: "Sha'ban",
      ticker: "Sha\u2019ban \u2756 Prepare ton Ramadan avec intention",
      icon: '\uD83C\uDF19',
      tags: ['agenda','hijri','adhkar','dhikr','salat','bestseller','pack'],
      fallback: ['apprendre','digital'],
      cta_collection: '/collections/agendas-et-planners-islamiques',
      cta_label: 'Preparer le Ramadan',
      modal_title: "Sha\u2019ban : le mois de preparation",
      modal_desc: 'Agenda hijri et adhkars : commence a poser tes intentions avant le mois sacre.'
    }

  ];

  /* ── 5. Trouver l'evenement actif (le plus urgent) ── */
  function getActiveEvent() {
    var now     = new Date();
    var h       = toHijri(now);
    var actives = EVENTS.filter(function (e) {
      return e.hm === h.m && h.d >= e.hd_start && h.d <= e.hd_end;
    });
    if (!actives.length) return null;
    actives.sort(function (a, b) { return b.urgency - a.urgency; });
    return actives[0];
  }

  /* ── 6. Obtenir les produits pour un evenement (automatique) ── */
  function getEventProducts(event, limit) {
    limit = limit || 3;
    if (!event) return [];
    /* Essai 1 : tags principaux */
    var prods = resolveProducts(event.tags, limit);
    /* Essai 2 : fallback si moins de 2 produits trouves */
    if (prods.length < 2 && event.fallback) {
      var extra = resolveProducts(event.fallback, limit - prods.length);
      /* Eviter les doublons */
      extra.forEach(function (ep) {
        if (!prods.some(function (pp) { return pp.handle === ep.handle; })) {
          prods.push(ep);
        }
      });
    }
    return prods.slice(0, limit).map(normalizeProduct);
  }

  /* ── 7. Jours restants dans l'evenement ── */
  function daysLeft(event) {
    var h = toHijri(new Date());
    return Math.max(0, event.hd_end - h.d);
  }

  /* ── 8. Date hijri du jour ── */
  function todayHijri() { return toHijri(new Date()); }

  /* ── Export global ── */
  G.IQRA_CAL = {
    toHijri:          toHijri,
    getActiveEvent:   getActiveEvent,
    getEventProducts: getEventProducts,
    resolveProducts:  resolveProducts,
    daysLeft:         daysLeft,
    todayHijri:       todayHijri,
    EVENTS:           EVENTS
  };

}(window));